import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Breadcrumb } from '../shared/breadcrumb/breadcrumb';

@Component({
  selector: 'app-aboutus',
  standalone: true,
  imports: [RouterLink, Breadcrumb],
  templateUrl: './aboutus.component.html',
  styleUrl: './aboutus.component.css'
})
export class AboutusComponent {}
